import { RouterProvider } from 'react-router-dom';
import routes from 'services/routes';

import {
  PageLoadingProvider,
  SettingsProvider,
  ThemeProvider,
  UserProvider,
} from '@/state/providers.tsx';
import { InactivityProvider, SessionDurationProvider } from '@/features/auth';
import { PdfEngineProvider } from '@/features/pdf-engine';
import { AppThemeProvider } from './AppThemeProvider';
import { CSSVariablesProvider } from './CSSVariablesProvider';

function App() {
  return (
    <UserProvider>
      <ThemeProvider>
        <SettingsProvider>
          <AppThemeProvider>
            <CSSVariablesProvider>
              <PageLoadingProvider>
                <SessionDurationProvider>
                  <InactivityProvider>
                    <PdfEngineProvider>
                      <RouterProvider router={routes} />
                    </PdfEngineProvider>
                  </InactivityProvider>
                </SessionDurationProvider>
              </PageLoadingProvider>
            </CSSVariablesProvider>
          </AppThemeProvider>
        </SettingsProvider>
      </ThemeProvider>
    </UserProvider>
  );
}

export default App;
